export const config = {
  apiUrl: window.location.origin + "/api",
  authUrl: window.location.origin + "/api/auth",
};

export const isDev = import.meta.hot !== undefined;
